import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "form-label fw-bold d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex flex-row" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "grid_view", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "list", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "container"
}
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "form-label fw-bold d-flex align-items-center" }, null, -1)
const _hoisted_15 = { class: "d-flex flex-row" }
const _hoisted_16 = { class: "me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_product_selector = _resolveComponent("product-selector")!
  const _component_ProductTileView = _resolveComponent("ProductTileView")!
  const _component_InputProductList = _resolveComponent("InputProductList")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.pageUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.pageUI.isReady())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fieldLabel), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`${_ctx.$t('productsWithCnkCode')} (${_ctx.cnkCodes.length})`), 1),
                _createVNode(_component_product_selector, {
                  buttonClass: "me-2 p-1 border-1",
                  errors: _ctx.errors,
                  "single-product": false,
                  onSelectProducts: _ctx.addProducts
                }, null, 8, ["errors", "onSelectProducts"]),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("button", {
                    class: _normalizeClass(`btn btn-icon p-1 me-2 ${_ctx.gridView ? 'selected-view' : 'border-1'}`),
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchToGridView && _ctx.switchToGridView(...args)))
                  }, _hoisted_8, 2)
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("button", {
                    class: _normalizeClass(`btn btn-icon p-1 ${_ctx.gridView ? 'border-1' : 'selected-view'}`),
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchToListView && _ctx.switchToListView(...args)))
                  }, _hoisted_11, 2)
                ])
              ])
            ]),
            _withDirectives(_createVNode(_component_ProductTileView, {
              visible: _ctx.gridView,
              modelValue: _ctx.cnkCodes,
              "onUpdate:modelValue": _ctx.cnksUpdated
            }, null, 8, ["visible", "modelValue", "onUpdate:modelValue"]), [
              [_vShow, _ctx.gridView]
            ]),
            (!_ctx.gridView)
              ? (_openBlock(), _createBlock(_component_InputProductList, {
                  key: 0,
                  "model-value": _ctx.cnkCodes,
                  errors: _ctx.errors,
                  class: "mt-3",
                  name: _ctx.name + '-cnk-codes-list',
                  height: _ctx.height,
                  "onUpdate:modelValue": _ctx.cnksUpdated
                }, null, 8, ["model-value", "errors", "name", "height", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.pageUI.isReady())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(`${_ctx.$t('productsWithProductCode')} (${_ctx.productCodes.length})`), 1),
                    (_ctx.productCodes.length === 0)
                      ? (_openBlock(), _createBlock(_component_input_checkbox_boolean, {
                          key: 0,
                          modelValue: _ctx.showProductCodeProducts,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showProductCodeProducts) = $event)),
                          label: "",
                          name: _ctx.name,
                          errors: _ctx.errors
                        }, null, 8, ["modelValue", "name", "errors"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _withDirectives(_createVNode(_component_ProductTileView, {
                  visible: _ctx.gridView && _ctx.showProductCodeProducts,
                  useProductCodes: true,
                  modelValue: _ctx.productCodes,
                  "onUpdate:modelValue": _ctx.productCodesUpdated
                }, null, 8, ["visible", "modelValue", "onUpdate:modelValue"]), [
                  [_vShow, _ctx.gridView && _ctx.showProductCodeProducts]
                ]),
                (!_ctx.gridView && _ctx.showProductCodeProducts)
                  ? (_openBlock(), _createBlock(_component_InputProductList, {
                      key: 0,
                      "model-value": _ctx.productCodes,
                      errors: _ctx.errors,
                      class: "mt-3",
                      name: _ctx.name + '-product-codes-list',
                      height: _ctx.height,
                      useProductCodes: true,
                      "onUpdate:modelValue": _ctx.productCodesUpdated
                    }, null, 8, ["model-value", "errors", "name", "height", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}